import { EntityState } from '@ngrx/entity';
import { Campaign } from '../../../models/campaigns-models/campaign';
import { campaignsAdapter, platformsAdapter } from './campaign-adapters';
import { CampaignFilters, SortType } from '../../../models/campaigns-models/campaign-filters';
import { ClientTokens } from '../../../models/campaigns-models/client-tokens';
import { MediaPlatformAccount } from '../../../models/campaigns-models/media-platform-account';
import { PlatformValidationRules } from '../../../models/campaigns-models/platform-validation-rules';


export interface CampaignState extends EntityState<Campaign> {
}

export interface PlatformState extends EntityState<MediaPlatformAccount> {
}

export interface CampaignFeatureState {
  campaigns: CampaignState;
  platforms: PlatformState;
  filters: CampaignFilters;
  clientTokens: ClientTokens;
  validationRules: PlatformValidationRules[];
}


export const InitialState: CampaignFeatureState = {
  campaigns: campaignsAdapter.getInitialState(),
  platforms: platformsAdapter.getInitialState(),
  filters: {
    title: '', // Filtered in the FE
    type: null,
    status: null,
    from: null,
    to: null,
    sortType: SortType.NEWEST,
    // listings
    gbpAccountIds: [],
    platform: [],
  },
  clientTokens: null,
  validationRules: null,
};
